import { Provider } from "@angular/core";
import { map, Observable } from "rxjs";
import { UseCase } from "../../../core/use-case";
import { MappedRetrieveWeeksListAbsenceResponse } from "../../models/personnel.model";
import { PersonnelRepository } from "../../repositories/personnel.repository";

interface retrieveWeeksListAbsenceUseCaseParams {}
export class RetrieveWeeksListAbsenceUseCase
  implements UseCase<retrieveWeeksListAbsenceUseCaseParams, any>
{
  constructor(private repo: PersonnelRepository) {}

  execute(): Observable<MappedRetrieveWeeksListAbsenceResponse> {
    return this.repo.retrieveWeeksListAbsence().pipe(
      map((data) => {
        let realDataSource$ = data;
        return realDataSource$;
      }),
    );
  }
}

const retrieveWeeksListAbsenceFactory = (repo: PersonnelRepository) =>
  new RetrieveWeeksListAbsenceUseCase(repo);
export const retrieveWeeksListAbsenceProvider: Provider = {
  provide: RetrieveWeeksListAbsenceUseCase,
  useFactory: retrieveWeeksListAbsenceFactory,
  deps: [PersonnelRepository],
};
